import { megaMenu } from '../../utils/mega-menu';
import { mobileMenu } from '../../utils/mobile-menu';

const header = document.querySelector('.header');
const darkHeroBlock = document.querySelector('.hero--merge-with-header.has-dark-background:first-child');

if (header) {
  const logo = document.querySelector('.header__logo');
  const burger = document.querySelector('.header__burger');

  if (darkHeroBlock) {
    header.classList.add('has-always-dark-background');
  }

  // Click on the logo closes all visible menus
  logo.addEventListener('click', (e) => {
    if (megaMenu.isVisible()) {
      e.preventDefault();
      megaMenu.hide();
    }

    if (mobileMenu.isVisible()) {
      e.preventDefault();
      mobileMenu.hide();
    }
  });

  // Click on burger toggles the mobile menu
  burger.addEventListener('click', (e) => mobileMenu.toggle());
}

document.addEventListener('alpine:init', () => {
  Alpine.data('header', () => ({
    switchLanguage(lang) {
      const link = document.head.querySelector(`link[hreflang="${lang}"]`);

      console.log(lang, link);

      if (link?.href) {
        window.location.href = link.href;
      }
    },
  }));
});